import script from "./FormButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FormButton.vue?vue&type=script&setup=true&lang=js"

import "./FormButton.vue?vue&type=style&index=0&id=0ea5ad37&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea5ad37"]])

export default __exports__